export const GROUP_ROUTES = {
  HOME: '',
  INDEX: 'home-group',
  SUGGESTION_GROUP: 'suggestion-groups',
  RESTRICTED_GROUP: 'restricted-group',
  SINGLE_GROUP: 'single-group',
  SINGLE_POST: 'post-id',
  GROUP_DISCUSSION: 'group-discussion',
  GROUP_HASHTAGS: 'group-hashtags',
  HOME_HASHTAGS: 'home-hashtags',
  SINGLE_HASHTAGS: 'single-hashtag',
  GROUP_USERS: 'group-users',
  GROUP_MULTIMEDIA: 'group-multimedia',
  GROUP_SETTINGS: 'group-settings',
  HOME_GROUP_SETTINGS: 'home-group-settings',
  CUSTOMIZE_GROUP_SETTINGS: 'customize',
  SECURITY_GROUP_SETTINGS: 'security',
  ADMIN_GROUP_SETTINGS: 'admins',
  RULES_GROUP_SETTINGS: 'rules',
  QUIZZ_GROUP_SETTINGS: 'quizz',
  GROUP_STATS: 'group-stats',
  HOME_GROUP_STATS: 'home-group-stats',
  ADHESION_LIST_GROUP: 'adhesion-list',
  VALIDATION_USER: 'validation-user',
  POST_PENDING: 'post-pending',
  POST_SIGNALIZATION: 'post-signalization',
  POST_MODERATION: 'post-moderation',
};
